import React, { useState } from "react";
import {
  Dialog,
  Divider,
  FormControl,
  IconButton,
  InputLabel,
  OutlinedInput,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useAuth } from "../../context/API_Client";
import { useEffect } from "react";
import CustomButton from "../../reusableComponents/CustomButton";
import { customToast } from "../../reusableComponents/customToaster/customToast";
import CustomDropdown from "../../reusableComponents/CustomDropdown";
import { nameRegex } from "../../reusableComponents/constants";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MultiSelect from "../../reusableComponents/CustomSelect/MultiSelect";

function CreateProduct({
  open,
  onClose,
  createdUnit,
  setCreatedUnit,
  selectedProduct,
  selectedCode,
  selectedDescription,
  selectedVersion,
  minAmount,
  maxAmount,
  businessUnit,
  currency,
  editing,
}) {

  console.log('businessUnit', businessUnit);


  const {
    addProduct,
    updateProduct,
    postPspConfigForFiltering,
    getBusinessUnits,
  } = useAuth();
  const [product, setProduct] = useState("");
  const [code, setCode] = useState("");
  const [description, setDescription] = useState("");

  const [codeEdited, setCodeEdited] = useState(false);

  const [validName, setValidName] = useState(true);
  const [validCode, setValidCode] = useState(true);
  const [validDescription, setValidDescription] = useState(true);

  const [businessUnitsData, setBusinessUnitsData] = useState();
  const [businessNameArr, setBusinessNameArr] = useState();
  const [businessCodeArr, setBusinessCodeArr] = useState();
  const [businessOptions, setBusinessOptions] = useState([])

  const [selectedBusinessName, setSelectedBusinessName] = useState([]);
  const [selectedBusinessCode, setSelectedBusinessCode] = useState([]);

  const [currencyCode, setCurrencyCode] = useState();
  const [selectedCurrencyCode, setSelectedCurrencyCode] = useState();

  const [minimumAmount, setMinimumAmount] = useState(minAmount);
  const [maximumAmount, setMaximumAmount] = useState(maxAmount);
  const [firstChange, setFirstChange] = useState(false);
  const loginUser = localStorage?.getItem("userDetails");
  const userObject = JSON.parse(loginUser);
  useEffect(() => {
    getBusinessUnits(
      function (data) {

        setBusinessUnitsData(data);
        if (businessUnit && !firstChange) {

          // const name = data.find(
          //   (legalEntitiy) => legalEntitiy?.code === businessUnit
          // )?.name;
          setSelectedBusinessName(businessUnit);
          setSelectedBusinessCode(businessUnit);
        }
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
    getBusinessUnits(
      function (data) {
        let codes = [];
        let names = [];
        let businessUnitOptions = []
        for (let i = 0; i < data?.length; i++) {
          codes.push(data[i]?.code);
          names.push(data[i]?.name);
          businessUnitOptions.push({ title: data[i]?.name, value: data[i]?.code })
        }
        setBusinessNameArr(names);
        setBusinessCodeArr(codes);
        setBusinessOptions(businessUnitOptions)
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  }, []);

  useEffect(() => {
    postPspConfigForFiltering(
      selectedBusinessCode?.length ? { legalEntities: selectedBusinessCode } : {},

      function (data) {

        if (currency && !firstChange) {
          setSelectedCurrencyCode(currency);
        }
        let codes = [];

        for (let i = 0; i < data?.currencyCodes?.length; i++) {
          codes.push(data?.currencyCodes[i]?.value);
        }
        setCurrencyCode(codes);
      },
      function (errMsg) {
        customToast("error", "high", errMsg);
      }
    );
  }, [selectedBusinessCode]);

  useEffect(() => {
    setProduct(selectedProduct);
    setCode(selectedCode);
    setDescription(selectedDescription);
  }, [selectedProduct, selectedCode, selectedDescription]);
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      setProduct("");
      setCode("");
      setDescription("");
      setMinimumAmount(null);
      setMaximumAmount(null);
      onClose();
    }
  };
  useEffect(() => {
    const regex = /^[a-zA-Z0-9_]+$/;
    const isValid = regex.test(code);

    if (code?.length > 0 && !isValid) setValidCode(false);
    else setValidCode(true);
  }, [code]);

  useEffect(() => {
    const isValid = nameRegex.test(product);

    if (product?.length > 0 && !isValid) setValidName(false);
    else setValidName(true);
  }, [product]);

  useEffect(() => {
    const htmlRegex = /.*<[^>]+>.*/;
    const isValid = !htmlRegex.test(description);
  }, [description]);

  const onSaveChange = () => {
    updateProduct(
      selectedCode,
      {
        name: product,
        code: selectedCode,
        description: description,
        businessUnits: selectedBusinessCode ? selectedBusinessCode : [],
        currencyCode: selectedCurrencyCode,
        maxAmount: maximumAmount,
        minAmount: minimumAmount,
        version: selectedVersion,
      },
      function (data) {
        customToast("success", "high", "Product updated");

        setCreatedUnit(!createdUnit);
        handleSaveChangeClose();
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };

  const onSave = () => {
    addProduct(
      {
        code: code,
        name: product,
        description: description,
        businessUnits: selectedBusinessCode ? selectedBusinessCode : [],
        currencyCode: selectedCurrencyCode,
        maxAmount: maximumAmount,
        minAmount: minimumAmount,
      },
      function (data) {
        customToast("success", "high", "Product added");

        setCreatedUnit(!createdUnit);
        handleSaveClose();
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };

  const handleSaveClose = () => {
    setProduct("");
    setCode("");
    setDescription("");
    setMinimumAmount(null);
    setMaximumAmount(null);
    onClose();
  };

  const handleSaveChangeClose = () => {
    onClose();
  };

  const handleSaveChangeCancel = (event) => {
    setProduct(selectedProduct);
    setCode(selectedCode);
    setDescription(selectedDescription);
    onClose();
  };
  const handleNameChange = (event) => {
    const newValue = event.target.value;
    setProduct(newValue);
  };

  const handleBUChange = (value) => {
    setSelectedBusinessCode(value)
    setSelectedBusinessName(value)
  }
  const updateSelect = (id, val) => {
    setFirstChange(true);
    if (id === "bussinessUnit") {
      setSelectedBusinessName(
        businessUnitsData?.find((ele) => ele?.code === val)?.name
      );

      setSelectedBusinessCode(val);

      setSelectedCurrencyCode(null);
      setMaximumAmount("");
      setMinimumAmount("");
      if (selectedCurrencyCode)
        customToast(
          "warning",
          "medium",
          "Changing business units resets currency"
        );
    }
    if (id === "currencyCode") {
      setSelectedCurrencyCode(val);
      setMaximumAmount("");
      setMinimumAmount("");
    }
    if (id === "maximumAmount") {
      setMaximumAmount(val);
    }
    if (id === "minimumAmount") {
      setMinimumAmount(val);
    }
  };

  const handleCodeChange = (event) => {
    setCodeEdited(true);
    const newValue = event.target.value;
    setCode(newValue);
  };

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };




  return (
    <div>
      <Dialog
        open={open}
        className="businessUnitModal"
        onKeyDown={handleKeyDown}
      >
        <div style={{ padding: "24px 24px 0px 24px" }}>
          <Typography
            className="SemiboldTwenty font-black-highest"
            style={{ marginBottom: "6px" }}
          >
            {!editing ? "Add Product" : "Edit Product"}
          </Typography>
        </div>
        <div style={{ padding: "6px 24px 0px 24px" }}>
          <Typography className="labelRegular font-black-high">
            {!editing
              ? "Add details about your product or service offering"
              : "Edit details about your product or service offering"}
          </Typography>
        </div>
        <Divider style={{ margin: "16px 24px" }} />

        <div
          style={{
            overflowY: "auto",
            width: "100%",
            gap: "12px",
            display: "flex",
            flexDirection: "column",
            padding: "0px 24px 24px 24px",
          }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              gap: "42px",
            }}
          >
            <div style={{ width: "calc(50% - 21px)" }}>
              <InputLabel
                className="bodyB2RegularText"
                sx={{ color: "var(--character-title-85, rgba(0, 0, 0, 0.85))" }}
                required={true}
              >
                Product Name
              </InputLabel>
              <>
                <OutlinedInput
                  value={product}
                  onChange={handleNameChange}
                  className="textFieldCreate"
                  size="small"
                  name="product"
                  style={{ width: "100%" }}
                  placeholder="Enter product name"
                  aria-describedby="outlined-title-helper-text"
                />
                {!validName && (
                  <Typography
                    className="error"
                    style={{
                      color: "#B9232F",
                      fontSize: "10px",
                      marginTop: "3px",
                    }}
                  >
                    <img
                      src="/assets/errorOutline.svg"
                      style={{ height: "15px", width: "12px" }}
                    />{" "}
                    Special characters are not allowed
                  </Typography>
                )}
              </>
            </div>

            <div style={{ width: "calc(50% - 21px)" }}>
              <div
                style={{ display: "flex", alignItems: "center" }}
                className="iconSpacing"
              >
                <InputLabel
                  className="bodyB2RegularText"
                  sx={{
                    color:
                      "var(--character-title-85, rgba(0, 0, 0, 0.85)) !important",
                  }}
                  required={true}
                >
                  Code
                </InputLabel>
                <Tooltip title="A code is a unique identifier that can be assigned to your product or service offerings">
                  <IconButton
                    sx={{
                      "&:hover": { backgroundColor: "transparent" },
                    }}
                    disableFocusRipple
                    disableTouchRipple
                  >
                    <InfoOutlinedIcon
                      sx={{
                        color:
                          "var(--character-title-85, rgba(0, 0, 0, 0.85)) !important",
                        width: "14px",
                        height: "14px",
                        order: 1,
                        marginLeft: "2px",
                        marginBottom: "8px",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </div>

              <OutlinedInput
                value={code}
                onChange={handleCodeChange}
                className="textFieldCreate"
                name="code"
                size="small"
                style={{ width: "100%" }}
                placeholder="Enter code"
                disabled={editing}
                aria-describedby="outlined-title-helper-text"
              />
              {!validCode && (
                <Typography
                  className="error"
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "3px",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "15px", width: "12px" }}
                  />{" "}
                  Special characters are not allowed
                </Typography>
              )}
            </div>
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              gap: "42px",
            }}
          >
            <div style={{ width: "calc(50% - 21px)" }}>
              <InputLabel
                className="bodyB2RegularText"
                sx={{
                  color:
                    "var(--character-title-85, rgba(0, 0, 0, 0.85)) !important",
                }}
                required={userObject?.businessUnits}
              >
                Business Unit{" "}
                <span style={{ fontSize: "12px" }}>(optional)</span>
              </InputLabel>
              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "100%" }}>
                  {businessNameArr?.length > 0 ? (
                    <MultiSelect
                      width={"100%"}
                      height={"40px"}
                      // optionsToDisplay={businessNameArr}
                      // optionsToSend={businessCodeArr}
                      defaultValue={selectedBusinessName}
                      value={selectedBusinessName}
                      onChange={handleBUChange}
                      options={businessOptions}
                      // dropDownId={"bussinessUnit"}
                      // updateSelect={updateSelect}
                      isClearable={true}
                      placeholder={"Select business unit"}
                    />
                  ) : (
                    <CustomDropdown
                      width={"100%"}
                      height={"40px"}
                      placeholder={"Select Business Unit"}
                    />
                  )}
                </div>
              </div>
            </div>
            <div style={{ width: "calc(50% - 21px)" }}>
              <InputLabel
                className="bodyB2RegularText"
                sx={{
                  color:
                    "var(--character-title-85, rgba(0, 0, 0, 0.85)) !important",
                }}
              >
                Currency Code
              </InputLabel>
              <div style={{ display: "flex", width: "100%" }}>
                <div style={{ width: "100%" }}>
                  {currencyCode?.length > 0 ? (
                    <CustomDropdown
                      width={"100%"}
                      height={"40px"}
                      optionsToDisplay={currencyCode}
                      optionsToSend={currencyCode}
                      defaultValue={selectedCurrencyCode}
                      dropDownId={"currencyCode"}
                      updateSelect={updateSelect}
                      isClearable={true}
                      placeholder={"Select currency code"}
                    />
                  ) : (
                    <CustomDropdown
                      width={"100%"}
                      height={"40px"}
                      placeholder={"Select currency code"}
                      disabled={true}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              gap: "42px",
            }}
          >
            <div style={{ width: "calc(50% - 21px)" }}>
              <InputLabel
                className={`bodyB2RegularText ${!selectedCurrencyCode && "disabledLabel"
                  }`}
                sx={{
                  color:
                    "var(--character-title-85, rgba(0, 0, 0, 0.85)) !important",
                }}
                required={false}
              >
                Minimum Amount
              </InputLabel>
              <FormControl fullWidth>
                <TextField
                  value={minimumAmount}
                  placeholder="Enter minimum amount"
                  id="outlined-number"
                  inputProps={{
                    pattern: "[0-9.]*",
                  }}
                  disabled={!selectedCurrencyCode}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  sx={{
                    height: "40px",
                    "& .MuiInputBase-root": {
                      width: "100% !important",
                    },
                  }}
                  onChange={(event) => {
                    const inputValue = event.target.value.replace(
                      /[^0-9.]/g,
                      ""
                    );
                    setMinimumAmount(inputValue);
                  }}
                />
              </FormControl>
              {minimumAmount && parseFloat(minimumAmount) === 0 ? (
                <Typography
                  className="error"
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "3px",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "15px", width: "12px" }}
                  />
                  {"Minimum amount should be greater than zero"}
                </Typography>
              ) : minimumAmount && parseFloat(minimumAmount) > 1000000 ? (
                <Typography
                  className="error"
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "3px",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "15px", width: "12px" }}
                  />
                  {"Minimum amount should be less than 1000000"}
                </Typography>
              ) : (
                <></>
              )}
            </div>
            <div style={{ width: "calc(50% - 21px)" }}>
              <InputLabel
                className={`bodyB2RegularText ${!selectedCurrencyCode && "disabledLabel"
                  }`}
                sx={{
                  color:
                    "var(--character-title-85, rgba(0, 0, 0, 0.85)) !important",
                }}
                required={false}
              >
                Maximum Amount
              </InputLabel>
              <FormControl fullWidth>
                <TextField
                  value={maximumAmount}
                  placeholder="Enter maximum amount"
                  id="outlined-number"
                  inputProps={{
                    pattern: "[0-9.]*",
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  disabled={!selectedCurrencyCode}
                  sx={{
                    height: "40px",
                    "& .MuiInputBase-root": {
                      width: "100% !important",
                    },
                  }}
                  onChange={(event) => {
                    const inputValue = event.target.value.replace(
                      /[^0-9.]/g,
                      ""
                    );
                    setMaximumAmount(inputValue);
                  }}
                />
              </FormControl>

              {maximumAmount && parseFloat(maximumAmount) === 0 ? (
                <Typography
                  className="error"
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "3px",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "15px", width: "12px" }}
                  />
                  {"Maximum amount should be greater than 0"}
                </Typography>
              ) : minimumAmount &&
                maximumAmount &&
                parseFloat(minimumAmount) > parseFloat(maximumAmount) ? (
                <Typography
                  className="error"
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "3px",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "15px", width: "12px" }}
                  />
                  {
                    "Maximum amount should be greater than equal to minimum amount"
                  }
                </Typography>
              ) : parseFloat(maximumAmount) > 1000000 ? (
                <Typography
                  className="error"
                  style={{
                    color: "#B9232F",
                    fontSize: "10px",
                    marginTop: "3px",
                    display: "flex",
                    alignItems: "flex-start",
                  }}
                >
                  <img
                    src="/assets/errorOutline.svg"
                    style={{ height: "15px", width: "12px" }}
                  />
                  {"Maximum amount should be less than 1000000"}
                </Typography>
              ) : (
                <></>
              )}
            </div>
          </div>

          <div className="productDescription">
            <InputLabel
              className="bodyB2RegularText"
              sx={{ color: "var(--character-title-85, rgba(0, 0, 0, 0.85))" }}
            >
              Description
            </InputLabel>

            <OutlinedInput
              value={description}
              onChange={handleDescriptionChange}
              multiline
              rows={3}
              size="small"
              placeholder="Enter product description"
              aria-describedby="outlined-name-helper-text"
              sx={{ width: "100%", height: "80px" }}
            />
            {!validDescription && (
              <Typography
                className="error"
                style={{
                  color: "#B9232F",
                  fontSize: "10px",
                  marginTop: "3px",
                }}
              >
                <img
                  src="/assets/errorOutline.svg"
                  style={{ height: "15px", width: "12px" }}
                />{" "}
                HTML Tags are not allowed
              </Typography>
            )}
          </div>
        </div>

        <div
          style={{
            paddingBottom: "24px",
            paddingTop: "24px",
            paddingRight: "24px",
            display: "flex",
            justifyContent: "end",
            boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
          }}
        >
          <div style={{ paddingRight: "20px" }}>
            <CustomButton
              text={"Cancel"}
              type={"secondary"}
              size={"sm"}
              onClick={!editing ? handleSaveClose : handleSaveChangeCancel}
            />
          </div>
          <CustomButton
            text={!editing ? "Save" : "Save Changes"}
            type={"secondary"}
            size={"sm"}
            variant={"contained"}
            disabled={
              !validName ||
              !validCode ||
              !validDescription ||
              product?.length == 0 ||
              code?.length == 0 ||
              parseFloat(maximumAmount) < parseFloat(minimumAmount) ||
              parseFloat(maximumAmount) > 1000000
            }
            onClick={!editing ? onSave : onSaveChange}
          />
        </div>
      </Dialog>
    </div>
  );
}

export default CreateProduct;
